module.exports = __webpack_public_path__ + "static/media/addMemKan.cad4daa3.jpg";